"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VITAL_NAMES = void 0;
const VITAL_NAMES = exports.VITAL_NAMES = {
  FIRST_PAINT: 'fp',
  FIRST_CONTENTFUL_PAINT: 'fcp',
  FIRST_INPUT_DELAY: 'fi',
  LARGEST_CONTENTFUL_PAINT: 'lcp',
  CUMULATIVE_LAYOUT_SHIFT: 'cls',
  INTERACTION_TO_NEXT_PAINT: 'inp',
  LONG_TASK: 'lt',
  TIME_TO_FIRST_BYTE: 'ttfb'
};